<template>
  <div style="width: 100%; text-align: center; padding-bottom: 1em">
    <p
      style="
        font-size: 0.875em;
        color: #3c4043;
        text-align: center;
        opacity: 0.8;
        margin-top: 4em;
        margin-bottom: 0;
      "
    >
      &copy; {{ new Date().getFullYear() }} Our Space
    </p>
    <small style="font-size: 0.6em; opacity: 0.8; margin-top: 0em; bottom: 10%">
      Powered by
      <a
        style="text-decoration: none; color: #000000"
        href="https://softwebdigital.com"
        target="_blank"
      >
        Soft-Web Digital
      </a>
    </small>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
